export const EH_DEFAULT_SITE = "https://e-hentai.org";
export const EXH_DEFAULT_SITE = "https://exhentai.org";
export const EH_DEFAULT_API = "https://api.e-hentai.org/api.php";

export interface ListingUrlOptions {
  /** site origin without a trailing slash */
  site: string;
  /** only expunged galleries (`f_sh=on`) */
  expunged?: boolean;
  /** `next=<gid>`: the page after this gid, newest first; omit for the first page */
  next?: number | null;
  /** E-Hentai category exclusion mask (`f_cats`); tests use 767 = Non-H only */
  categoryMask?: number;
}

export function listingUrl(o: ListingUrlOptions): string {
  const q = new URLSearchParams();
  if (o.expunged) q.set("f_sh", "on");
  if (o.categoryMask !== undefined) q.set("f_cats", String(o.categoryMask));
  if (o.next != null) q.set("next", String(o.next));
  const query = q.toString();
  return `${o.site.replace(/\/+$/, "")}/${query ? `?${query}` : ""}`;
}

export function archiverUrl(site: string, gid: number, token: string): string {
  return `${site.replace(/\/+$/, "")}/archiver.php?gid=${gid}&token=${token}`;
}
